export default __webpack_public_path__ + "static/Face6-fb3122201dcf861795a435faad29713e.jpg";